module.exports = __webpack_public_path__ + "static/media/023.92ecff2f.png";